<template>
  <span
    :style="badgeStyle"
    class="plan-badge">
    {{ plan }}
  </span>
</template>

<script>
import { getPlanBadgeStyle } from '@/utils/plan-badge'

export default {
  name: 'PlanBadge',
  props: {
    // O rótulo exibido no chip.
    plan: {
      type: String,
      required: true
    },
    // Código do plano no billing, quando quem chama o tem. Sem ele a cor é
    // resolvida pelo rótulo, que é o caminho legado.
    code: {
      type: String,
      default: null
    }
  },
  computed: {
    badgeStyle () {
      return getPlanBadgeStyle(this.code || this.plan)
    }
  }
}
</script>

<style scoped>
.plan-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  padding: 0.125rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/PlanBadge.vue